@if (waitingForFilterResults) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="date-list-header">
  <h1 class="page-title">{{ entityTypeName }}</h1>

  <div class="filter-container">
    <mat-button-toggle-group
      (change)="userChangedFilter($event)"
      multiple="true">
      <mat-button-toggle
        value="PendingMyAction"
        [checked]="isFilterActive(MyWorkFilter.PendingMyAction)">
        Pending My Action
      </mat-button-toggle>
      <mat-button-toggle
        value="TaskingIAssigned"
        [checked]="isFilterActive(MyWorkFilter.TaskingIAssigned)">
        Tasking I Assigned
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <span class="date-count">{{ filteredDates.length }} dates</span>
</div>

<div class="table-container">
  <table mat-table [dataSource]="filteredDates" matSort (matSortChange)="sortData($event)" class="dates-table">

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let date" class="status-cell">
        @if (date.actionCompleted) {
          <mat-icon class="status-icon completed" matTooltip="Completed">check_circle</mat-icon>
        } @else if (isOverdue(date)) {
          <mat-icon class="status-icon overdue" matTooltip="Overdue">error</mat-icon>
        } @else if (isDueSoon(date)) {
          <mat-icon class="status-icon due-soon" matTooltip="Due within 30 days">warning</mat-icon>
        } @else {
          <mat-icon class="status-icon pending" matTooltip="Pending">schedule</mat-icon>
        }
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let date" class="name-cell">
        <span class="date-name">{{ date.name || '—' }}</span>
        <span class="date-type-badge" matTooltip="Email / Calendar reminders">
          Email: {{ date.emailNotificationEnabled ? 'Yes' : 'No' }} | Cal: {{ date.calendarNotificationEnabled ? 'Yes' : 'No' }}
        </span>
      </td>
    </ng-container>

    <!-- Event Date Column -->
    <ng-container matColumnDef="eventDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Important Date</th>
      <td mat-cell *matCellDef="let date"
          [class.overdue-text]="isOverdue(date)"
          [class.due-soon-text]="isDueSoon(date)">
        {{ formatDate(date.eventDate) }}
      </td>
    </ng-container>

    <!-- Reminder Date Column -->
    <ng-container matColumnDef="reminderDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Reminder</th>
      <td mat-cell *matCellDef="let date">{{ formatDate(date.reminderDate) }}</td>
    </ng-container>

    <!-- Assigned To Column -->
    <ng-container matColumnDef="assignedTo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Assigned To</th>
      <td mat-cell *matCellDef="let date">{{ formatAssignedTo(date.assignedTo) }}</td>
    </ng-container>

    <!-- Owner Column -->
    <ng-container matColumnDef="owner">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Owner</th>
      <td mat-cell *matCellDef="let date">{{ getUserName(date.owner) }}</td>
    </ng-container>

    <!-- Entity Name Column -->
    <ng-container matColumnDef="entityName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Source</th>
      <td mat-cell *matCellDef="let date">{{ date.entityName || '—' }}</td>
    </ng-container>

    <!-- Entity Type Column -->
    <ng-container matColumnDef="entityType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let date">
        @if (date.entityType) {
          <mat-chip-option class="entity-type-chip" [selectable]="false" [removable]="false">
            {{ date.entityType }}
          </mat-chip-option>
        }
      </td>
    </ng-container>

    <!-- Required Action Column -->
    <ng-container matColumnDef="requiredAction">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Required Action</th>
      <td mat-cell *matCellDef="let date" class="action-cell">{{ (date.requiredAction || date.description || '').length > 200 ? (date.requiredAction || date.description || '').substring(0, 200) + '...' : (date.requiredAction || date.description || '') }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        class="date-row"
        (click)="onRowClicked(row)">
    </tr>

    <!-- No data row -->
    <tr class="mat-row no-data-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <div class="no-data-message">
          <mat-icon>event_busy</mat-icon>
          <p>No important dates found</p>
        </div>
      </td>
    </tr>
  </table>
</div>
